<div cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
	<modal-header-default
		class="border"
		[options]="{
			headerTitleKey: null,
			headerTitle: null
		}">
		<a (click)="closeModal()" header-right>{{ "close" | translate }}</a>
	</modal-header-default>
	@if (termsError) {
		<div class="error-container">
			<bp-try-again-error
				[title]="'terms_error_fetching_title' | translate"
				[message]="'terms_error_fetching_subtitle' | translate"
				[tryAgainMessage]="'try_again' | translate"
				(onRetry)="refetchVm()"></bp-try-again-error>
		</div>
	} @else {
		@if (vm$ | async; as vm) {
			<div class="confirm-container">
				<div class="subheader">
					<span class="subheader-title"> {{ "almost_there_staking" | translate }} </span>
					<span class="subheader-subtitle"> {{ "auto_staking_confirmation_description" | translate }}</span>
				</div>
				@if (vm.overViewState.autoStakeAssets.length > 0) {
					<hr class="confirmation-divider" />
					<div>
						<span class="font-medium added-to-your-earning">
							{{ "auto_staking_added_to_earning" | translate }}
							{{
								vm.overViewState.autoStakeAssets.length > 1
									? ("auto_staking_added_to_earning_plural"
										| translate: [vm?.overViewState.autoStakeAssets?.length])
									: ("auto_staking_added_to_earning_single" | translate: [1])
							}}</span
						>
						<div class="asset-container-field">
							@for (autoStakeAsset of vm.overViewState.autoStakeAssets; track autoStakeAsset) {
								<div class="asset-item-box">
									<div>
										<img
											class="asset-icon"
											[src]="autoStakeAsset.logo"
											(error)="img.src = defaultLogo"
											[title]="'logo_alt_text' | translate"
											#img />
										<span> {{ autoStakeAsset.assetSymbol }}</span>
									</div>
									<span class="yield-text">
										{{ autoStakeAsset.yield | fiat_precision }}%/{{
											"yield_year" | translate
										}}</span
									>
								</div>
							}
						</div>
						@if (hasLockedAssets) {
							<span class="locked-asset-warning">
								{{ "auto_staking_locked_asset_warning" | translate }}
							</span>
						}
						<!-- Vision warning -->
						@if ((web3Phase$ | async).phase === WEB3_MERGE_PHASE.PostMerge) {
							<div class="vision-warning">
								<span class="vision-warning-1">
									{{ "auto_staking_opt_in_vision_warning_1" | translate }}
								</span>
								<span class="vision-warning-2">
									{{ "auto_staking_opt_in_vision_warning_2" | translate }}
								</span>
							</div>
						}
					</div>
				}
				<hr class="confirmation-divider" />
				<div class="terms-container">
					<span>
						{{ "staking_payout_interval" | translate }}: {{ "staking_rewards_weekly" | translate }}</span
					>
					@if (isDynamictermAndConditionActive$ | async) {
						<terms-and-conditions-updates
							[bundles]="vm.agreementBundles"
							(onTriggerChange)="triggerChangeHandler()"></terms-and-conditions-updates>
					} @else {
						<div class="auto-staking-terms-wrapper">
							<form [formGroup]="termsForm">
								<div class="term">
									<p>
										{{ "auto_staking_opt_in_term_1" | translate }}
										<a [href]="getTermLink()" target="_blank">
											{{ "auto_staking_opt_in_term_link" | translate }}</a
										>
										{{ "auto_staking_opt_in_term_2" | translate: null : true }}
									</p>
									<toggle-input-ui formControlName="autoStaking"></toggle-input-ui>
								</div>
							</form>
						</div>
					}
				</div>
				<button
					(click)="continue()"
					class="btn btn-primary btn-lg font-bold submit-btn"
					type="button"
					role="button"
					[disabled]="disableFormCheck() || apiLoading || disableButton"
					>{{ "auto_staking_turn_on" | translate }}
				</button>
			</div>
		} @else {
			<div>
				<loading-spinner></loading-spinner>
			</div>
		}
	}
</div>
